// src/pages/HotelDetails/HotelDetailsPage.jsx
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import { HotelDetails } from "../../Features/CustomPackages";

export default function HotelDetailsPage({ url }) {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Get hotel data passed via state
  const hotelData = location.state?.hotelData;
  const checkin = location.state?.checkin;
  const checkout = location.state?.checkout;

  const handleBack = () => {
    navigate(-1); // Go back to previous page (HotelList)
  };

  if (!hotelData) {
    return (
      <Container>
        <div className="alert alert-danger">Hotel data not found</div>
        <button onClick={handleBack} className="btn btn-primary">
          Back to Hotels
        </button>
      </Container>
    );
  }

  return (
    <Container>
      <HotelDetails
        dataFromList={hotelData}
        onReturn={handleBack}
        checkin={checkin}
        checkout={checkout}
        url={url}
      />
    </Container>
  );
}